// extracted by mini-css-extract-plugin
module.exports = {"sider":"Sider_sider__12SKn","brand":"Sider_brand__cCZTp","menuContainer":"Sider_menuContainer__1M8-L"};